// Small per-device preferences (localStorage; every access is guarded).
const get = (k: string, d: boolean) => {
  try {
    const v = localStorage.getItem('gcb.pref.' + k);
    return v === null ? d : v === '1';
  } catch {
    return d;
  }
};
export const prefs = {
  offerSave: () => get('offerSave', true),
  offerFill: () => get('offerFill', true),
  set(k: 'offerSave' | 'offerFill', v: boolean) {
    try {
      localStorage.setItem('gcb.pref.' + k, v ? '1' : '0');
    } catch {
      /* storage unavailable */
    }
  },
};
